import React, { useState, useRef, useEffect } from 'react';
import AdminAppBody from "../../../../components/admin/AdminAppBody";
const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [chatHistory, setChatHistory] = useState(['hi']);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentChatId, setCurrentChatId] = useState();
  const [isTyping, setIsTyping] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  const generateBotResponse = (userMessage) => {
    const responses = [
      "Hello! How can I help you today?",
      "That's an interesting question!",
      "I understand what you're asking about.",
      "Great question! Here's some helpful information.",
      "Thanks for reaching out! What would you like to know more about?",
      "Let me break this down for you.",
      "That's a common concern. Here's how I would approach it...",
      "Excellent point! This info should help."
    ];
    return responses[Math.floor(Math.random() * responses.length)];
  };
  const handleSendMessage = (messageText) => {
    if (!messageText.trim()) return;
    const userMessage = {
      id: Date.now().toString(),
      text: messageText,
      isUser: true,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, userMessage]);
    setMessageInput('');
    if (messages.length === 0) {
      setChatHistory(prev => [messageText, ...prev]);
      setCurrentChatId(messageText);
    }
    setIsTyping(true);
    setTimeout(() => {
      const botMessage = {
        id: (Date.now() + 1).toString(),
        text: generateBotResponse(messageText),
        isUser: false,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, botMessage]);
      setIsTyping(false);
    }, 1000);
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage(messageInput);
    }
  };
  const handleNewChat = () => {
    setMessages([]);
    setCurrentChatId(undefined);
  };
  const handleRemoveAll = () => {
    setChatHistory([]);
    setMessages([]);
    setCurrentChatId(undefined);
  };
  const handleSelectChat = (chatId) => {
    setCurrentChatId(chatId);
    setMessages([]);
  };
  const filteredHistory = chatHistory.filter(chat =>
    chat.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <AdminAppBody
      content={
        <div className="container-fluid p-3">
          <div className="row gx-4 gy-3 flex-column-reverse flex-md-row">
            {/* Chat Area */}
            <div className="col-12 col-md-8">
              <h5>💬 SysInsight Chatbot</h5>
              <div style={{ height: '400px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', marginBottom: '10px', borderRadius: '5px' }}>
                {messages.map((msg) => (
                  <div key={msg.id} style={{ textAlign: msg.isUser ? 'right' : 'left', margin: '10px 0' }}>
                    <div><strong>{msg.isUser ? 'You' : 'Bot'}:</strong></div>
                    <div>{msg.text}</div>
                    <small>{msg.timestamp.toLocaleTimeString()}</small>
                  </div>
                ))}
                {isTyping && <div><em>Bot is typing...</em></div>}
                <div ref={messagesEndRef} />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type your message..."
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  onKeyPress={handleKeyPress}
                  disabled={isTyping}
                />
                <button className="btn btn-primary" onClick={() => handleSendMessage(messageInput)} disabled={!messageInput.trim() || isTyping}>Send</button>
              </div>
            </div>
            {/* Sidebar */}
            <div className="col-12 col-md-4">
              <div className="mb-3">
                <button onClick={handleNewChat} className="btn btn-primary w-100">➕ New Chat</button>
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="🔍 Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div>
                <h6 className="fw-bold">🗂️ Chat History</h6>
                <div className="border rounded p-2" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {filteredHistory.length > 0 ? (
                    filteredHistory.map((chat, i) => (
                      <div key={i} onClick={() => handleSelectChat(chat)} style={{ cursor: 'pointer', padding: '5px 0', borderBottom: '1px solid #eee' }}>
                        {chat}
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No chat history found</p>
                  )}
                </div>
                <button onClick={handleRemoveAll} className="btn btn-outline-danger btn-sm mt-2 w-100">🗑️ Clear All</button>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};
export default Chatbot;